<h2 mat-dialog-title>Switch to PAYG?</h2>
<mat-dialog-content>
    <p>{{ data.alreadyScheduled ? 'Your Pro access is scheduled to end on' : 'Your Pro subscription renews on' }} <strong>{{ data.renewalDate | date:'longDate' }}</strong>.</p>
    <div class="switch-option">
        <strong>Switch now</strong>
        <p>Pro access and surveyor seats end immediately. Unused paid time is not refunded or credited. Your data stays in your account, and future PAYG usage requires credits.</p>
        <button mat-stroked-button color="warn" type="button" (click)="dialogRef.close('now')">Switch now</button>
    </div>
    <div class="switch-option">
        <strong>Switch at renewal</strong>
        <p>Keep Pro access and surveyor seats until {{ data.renewalDate | date:'longDate' }}. The subscription then stops renewing and your account moves to PAYG.</p>
        <button mat-flat-button color="primary" type="button" (click)="dialogRef.close('renewal')">Switch at renewal</button>
    </div>
</mat-dialog-content>
<div mat-dialog-actions align="end">
    <button mat-stroked-button type="button" (click)="dialogRef.close()">Cancel</button>
</div>
